import { render, staticRenderFns } from "./formrecord.vue?vue&type=template&id=29725b17&"
import script from "./formrecord.vue?vue&type=script&lang=js&"
export * from "./formrecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports